<template>
  <div class="programme-main">
    <Header title="教学计划" type='0' route='/homeIndex'></Header>
    <van-sticky :offset-top="50">
      <van-tabs
        v-model="activeName"
        type="line"
        sticky
        animated
        @change="tabChange"
      >
        <template v-if="this.schoolCode == '10008'">
          <van-tab title="课程明细"></van-tab>
          <van-tab title="方案说明"></van-tab>
          <van-tab title="学分要求"></van-tab>
        </template>
        <template v-else>
          <van-tab title="教学计划"></van-tab>
          <van-tab title="培养方案"></van-tab>
        </template>
      </van-tabs>
      <template v-if="activeName == 0">
        <div class="executePlan_select">
          <div class="sem-drop">
            <div @click="showPicker2 = true">
              <p>{{ value2 || "院系名称" }}</p>
              <i></i>
            </div>
          </div>
          <div class="sem-drop">
            <div @click="showPicker1 = true">
              <p>{{ value1 || "所在年级" }}</p>
              <i></i>
            </div>
          </div>
          <div class="sem-drop">
            <div @click="fn4">
              <p>{{ value3 || "专业名称" }}</p>
              <i></i>
            </div>
          </div>
          <div class="sem-drop">
            <div @click="fn5">
              <p>{{ value4 || "教学计划" }}</p>
              <i></i>
            </div>
          </div>
        </div>

        <template v-if="this.schoolCode === '10008'">
          <van-popup v-model="showPicker1" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns1"
              @cancel="showPicker1 = false"
              @confirm="onConfirm1"
              :item-height="35"
            />
          </van-popup>
          <van-popup v-model="showPicker2" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns2"
              @cancel="showPicker2 = true"
              @confirm="onConfirm2"
              :item-height="35"
            />
          </van-popup>
          <van-popup v-model="showPicker3" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns3"
              @cancel="showPicker3 = false"
              @confirm="onConfirm3"
              :item-height="35"
            />
          </van-popup>
          <van-popup v-model="showPicker4" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns4"
              @cancel="showPicker4 = false"
              @confirm="onConfirm4"
              :item-height="35"
            />
          </van-popup>
        </template>

        <template v-else>
         <van-popup v-model="showPicker2" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns2"
            @cancel="showPicker2 = false"
            @confirm="onConfirm2"
            :item-height="35"
          />
        </van-popup>
        <van-popup v-model="showPicker1" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns1"
            @cancel="showPicker1 = false"
            @confirm="onConfirm1"
            :item-height="35"
          />
        </van-popup>
        <van-popup v-model="showPicker3" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns3"
            @cancel="showPicker3 = false"
            @confirm="onConfirm3"
            :item-height="35"
          />
        </van-popup>
        
        <van-popup v-model="showPicker4" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns4"
            @cancel="showPicker4 = false"
            @confirm="onConfirm4"
            :item-height="35"
          />
        </van-popup>
        </template>
      </template>
    </van-sticky>
    <template v-if="activeName == 0">
      <NOdata title="暂无搜索结果~" v-if="planList.length == 0"></NOdata>
      <template v-else>
        <div class="article">
					<div class="content" v-for="(item, index) in planList" :key="index">
						<span>{{ item.courseName }}</span>
						<span class="sp">学分：{{ item.credit }}</span>
						<span class="sp">课程属性：{{ item.courseAttribute }}</span
						><br />
						<span class="sp">总学时：{{ item.totalHours }}</span>
						<span class="sp">考核方式：{{ item.evaluationMode }}</span
						><br />
						<span class="sp">学期时：{{ item.Semester }}</span>
						<span class="sp">课程体系：{{ item.courseSystem }}</span
						><br />
						<span class="sp">课程编码：{{ item.courseCode }}</span>
						<span class="sp">开课单位：{{ item.courseUnits }}</span
						><br />
						<span class="sp">开设学期：{{ item.openSemester }}</span>
					</div>
				</div>
      </template>
    </template>
    <div v-if="activeName == 1" style="height: 100%">
      <pyfa />
    </div>
    <div v-if="activeName == 2" style="height: 100%">
      <xfyq />
    </div>
    <!-- <div class="footer">
				<button  class="btn" @click="fn()">查询</button>
		</div> -->
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
import pyfa from "./pyfa";
import xfyq from "./xfyq";
export default {
  provide(){
    return {
      kcmxIndex: this
    }
  },
  data() {
    return {
      // Planlist: [],
      grade: [], //年级
      value1: "", //年级
      academy: [], //院系
      value2: "", //院系
      major: [], //专业
      value3: "", //专业
      showPicker1: false,
      showPicker4: false,
      show1: false,
      columns1: [
        {
          values: [],
          className: "column1",
        },
      ],
      showPicker2: false,
      columns2: [
        {
          values: [],
          className: "column1",
        },
      ],
      columns4: [],
      yxmc: "",
      academyId: [],
      showPicker3: false,
      columns3: [],
      zymc: "",
      majorId: [],
      activeName: 0,
      active: 0,
      detailList: {},
      planList: [],
      pyfa: '',
      value4: ''
    };
  },
  components: {
    xfyq,
    pyfa
  },
  methods: {
    tabChange(activeName) {
      if (activeName == 0 && this.schoolCode == '10008') {
        if(this.value1 && this.value2 && this.value3 && this.value4){
          this.getList();
        }
      }
      if (activeName == 1) {
        // this.getList();
      }
    },
    //所在年级
    onConfirm1(value1) {
      console.log('value1:',value1)
      this.value3 = "";
      this.zymc = "";
      this.value4 = "";
      this.pyfa = "";
      this.value1 = value1.toString();
      this.showPicker1 = false;
      this.getMajor();
    },
    async getMajor() {
      //专业名称
      let concatList3 = [];
      let concatList4 = [];
      const params = {
        academyId: this.yxmc,
        grade: this.value1,
      };
      const res = await Api.getAnnualMajorList(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList3 = concatList3.concat(res.data[i].annumajorName);
        concatList4 = concatList4.concat(res.data[i].annumajorId);
      }
      this.columns3 = concatList3;
      this.majorId = concatList4;
    },
    //院系名称
    onConfirm2(value2, index) {
      console.log(1)
      this.value3 = "";
      this.zymc = "";
      this.value4 = "";
      this.pyfa = "";
      this.value2 = value2.toString();
      this.yxmc = this.academyId[index];
      this.showPicker2 = false;
      this.getMajor();
    },
    //专业名称
    onConfirm3(value3, index) {
      this.value3 = value3.toString();
      this.zymc = this.majorId[index];
      this.value4 = ""
      this.pyfa = ""
      this.showPicker3 = false;
      this.getPyfa();
    },
    onConfirm4(value, index) {
      this.value4 = value.toString();
      this.pyfa = this.columns4_id[index];
      this.showPicker4 = false;
      this.getList();
    },
    async getPyfa() {
      if (!this.zymc) {
        return this.$toast("请先选择专业");
      }
      const params = {
        academyId: this.yxmc,
        majorId: this.zymc,
        gardeId: this.value1,
        type: '2'
      };
      const res = await Api.pyfalist(params);
      if (res.data) {
        this.columns4 = res.data.map((e) => e.pyfamc);
        this.columns4_id = res.data.map((e) => e.jx0301id);
      }
    },
    fn4() {
      if (this.value1 == "") {
        this.$toast("请先选择年级");
      } else if (this.columns3.length == 0) {
        this.$toast("未查询到专业信息~");
      } else {
        this.showPicker3 = true;
      }
    },
    fn5() {
      if (this.zymc == "") {
        this.$toast("请先选择专业");
      } else {
        this.showPicker4 = true;
      }
    },
    async getGrade() {
      let concatList1 = [];
      const params = {
        semester: "",
      };
      const res = await Api.getGradeList(params);
      for (let i = 0; i < res.data.length; i++) {
        concatList1 = concatList1.concat(res.data[i].gradeName);
      }
      this.columns1[0].values = concatList1;
    },
    async getAcademy() {
      let concatList2 = [];
      let concatList5 = [];
      const res = await Api.getAcademyList();
      for (let i = 0; i < res.data.length; i++) {
        concatList2 = concatList2.concat(res.data[i].academyName);
        concatList5 = concatList5.concat(res.data[i].academyId);
      }
      this.columns2[0].values = concatList2;
      this.academyId = concatList5;
    },
    async getList() {
      const params = {
        academyId: this.yxmc,
        majorId: this.zymc,
        gardeId: this.value1,
        jx0301zxjhid: this.pyfa
      };
      const res = await Api.teachTeachingPlan(params);
      this.planList = res.data;
    },
  },
  created() {
    this.schoolCode=sessionStorage.getItem('schoolCode')
    this.getGrade();
    //院系名称
    this.getAcademy();
  },
};
</script>

<style lang="less" scoped>
.executePlan_select {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    // border-bottom: 1px solid @attendance-border-color-6;
    .sem-drop {
      max-width: 25%;
      > div {
        display: flex;
        align-items: center;
        color: @attendance-color-2;
        font-size: 14px;
        p {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        i {
          background: url(../../../../../static/img/Triangle.png) no-repeat
            center;
          width: 20px;
          height: 10px;
          background-size: 10px 8px;
          // margin-left: 5px;
        }
      }
    }
    select {
      background: none;
      border: 0;
      outline: 0;
    }
    /deep/.van-ellipsis.van-picker-column__item.van-picker-column__item--selected {
      color: @attendance-color-1;
      font-weight: 600;
    }
    /deep/.van-dropdown-menu__title--active {
      color: @attendance-color-2;
    }
    /deep/.van-popup {
      max-height: 40%;
    }
    /deep/.van-hairline--top-bottom:after,
    .van-hairline-unset--top-bottom:after {
      border-width: 0;
    }
  }

.article {
	height: 100%;
  padding: 10px 15px 10px;
	background-color: #f2f2f4;
	overflow-y: scroll;
}
.article .content {
  background: #fff;
  border-radius: 5px;
  padding-left: 20px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.article .content span:nth-child(1) {
  display: block;
  color: @attendance-color-1;
  font-size: 16px;
  padding-top: 20px;
  font-weight: 600;
  margin-bottom: 5px;
}
.article .content span {
  color: @attendance-color-2;
  font-size: 12px;
}
.article .content .sp {
  display: inline-block;
  width: 150px;
}
</style>
<style lang="less">
.programme-main {
  background-color: #f2f2f4;
  height: 100%;
  .van-tabs--line .van-tabs__wrap {
    border-bottom: 1px solid #f4f4f4;
    .van-tab--active {
      .van-tab__text--ellipsis {
        color: @attendance-color-8 !important;
      }
    }
    .van-tab__text--ellipsis {
      width: 100%;
      height: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: @attendance-color-2;
      letter-spacing: 0;
      text-align: center;
    }
    .van-tabs__line {
      background-color: @attendance-background-color-1 !important;
      width: 25px;
      height: 3px;
      border-radius: 1.5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/train/teachingPlan.vue